import isEmpty from "../helpers/isEmpty";

//-------------------------
// capitalise first letter
//-------------------------
export default function capitaliseFirstLetter(str) {
  if (!isEmpty(str)) {
    const cap_str = str.charAt(0).toUpperCase() + str.slice(1);
    return cap_str;
  } else {
    return str;
  }
}
